var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.867,
    height: 28.758,
    viewBox: "0 0 32.867 28.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-alt",
    d: "M29.785,60.758H3.081A3.081,3.081,0,0,1,0,57.677v-22.6A3.081,3.081,0,0,1,3.081,32h26.7a3.081,3.081,0,0,1,3.081,3.081v22.6A3.081,3.081,0,0,1,29.785,60.758ZM8.217,37.649a2.568,2.568,0,1,0,2.568,2.568A2.568,2.568,0,0,0,8.217,37.649Zm0,6.162a2.568,2.568,0,1,0,2.568,2.568A2.568,2.568,0,0,0,8.217,43.811Zm0,6.162a2.568,2.568,0,1,0,2.568,2.568A2.568,2.568,0,0,0,8.217,49.974ZM26.7,41.244V39.19a.77.77,0,0,0-.77-.77H13.1a.77.77,0,0,0-.77.77v2.054a.77.77,0,0,0,.77.77H25.934A.77.77,0,0,0,26.7,41.244Zm0,6.162V45.352a.77.77,0,0,0-.77-.77H13.1a.77.77,0,0,0-.77.77v2.054a.77.77,0,0,0,.77.77H25.934A.77.77,0,0,0,26.7,47.406Zm0,6.162V51.515a.77.77,0,0,0-.77-.77H13.1a.77.77,0,0,0-.77.77v2.054a.77.77,0,0,0,.77.77H25.934A.77.77,0,0,0,26.7,53.569Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8b4d04096a6cee054c73f6fa580ef7d1.svg";
export { ForwardRef as ReactComponent };